<div class="list-input overflow-auto" [class.border-danger]="error || (field.required && touched && items.length === 0)">
    @for (item of items; track item) {
        <div class="list-item p-2 d-flex bg-contrast-hover">
            @if (item.icon) {
                <kui-icon class="p-2 pr-3" [ngStyle]="{ color: item.color }" [fill]="item?.iconFill" [name]="item.icon" size="sm"></kui-icon>
            }
            <div class="flex-1 d-flex flex-column justify-content-center" (click)="onItemClick(item)">
                <div>
                    {{ item.name }}
                </div>
                @if (item.description) {
                    <div class="description muted">
                        <markdown [data]="item.description"></markdown>
                    </div>
                }
            </div>
            <div>
                <kui-icon kui-action name="trash-alt" class="p-2 muted-more" size="sm" (click)="deleteItem(item)"></kui-icon>
            </div>
        </div>
    }
</div>

<div class="d-flex">
    <div class="flex-1 invalid-feedback d-block">
        @if (field.required && touched && items.length === 0) {
            <div>
                {{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}
            </div>
        }
        @if (error) {
            <div>{{ error }}</div>
        }
    </div>

    @if (field.actions) {
        <div class="pt-2 pl-2">
            @for (action of field.actions; track action) {
                <span>
                    @if (!action.dropdownValues && action.name) {
                        <button kui-button color="secondary" (click)="onActionClick(action)">
                            {{ action.name }}
                        </button>
                    }
                    @if (!!action.dropdownValues && action.name) {
                        <kui-dropdown #dropdown [style]="'secondary'" [customContent]="dropdownContent" [customContentContext]="{ component: dropdown }">
                            {{ action.name }}
                        </kui-dropdown>
                    }
                    <ng-template #dropdownContent let-component="component">
                        <div style="min-width: 200px">
                            <kui-tree-select [nodes]="action.dropdownValues" (selectedNodeChanged)="onDropdownClick(component, action, $event)"></kui-tree-select>
                        </div>
                    </ng-template>
                </span>
            }
        </div>
    }
</div>
